import { markdownView } from '../../lib/markdown.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- calendar-day-dialog ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    day: String,
    journal: Boolean,
  }

  init() {
    this.state.loading = true
    this.state.error = ''
    this.state.errors = {}
    this.state.saving = false
    this.state.view = null
    this.state.writing = false
  }

  async onMount() {
    try {
      this.state.view = await window.App.api('planner/day', { day: this.props.day }, { silent: true })
      this.state.writing = this.props.journal || !this.state.view.journal
    } catch (error) {
      this.state.error = error.message
    } finally {
      this.state.loading = false
    }
    if (this.props.journal) this.focusJournal()
  }

  async focusJournal() {
    await this.tick()
    const node = this.root.querySelector('.ui-md-editor-fez')
    const editor = node && Fez(node)
    if (!editor) return
    editor.focusEnd()
  }

  write() {
    this.state.writing = true
    this.focusJournal()
  }

  async submit(event) {
    event.preventDefault()
    const form = this.formData(event.target)
    const params = { day: this.props.day, label: form.label || '', circled: Boolean(form.circled) }
    if (this.state.writing) params.journal = form.journal || ''
    this.state.saving = true
    try {
      const saved = await window.App.api('planner/day_save', params)
      window.Dialog.close(saved)
    } catch (error) {
      if (error.code === 'validation_failed') this.state.errors = error.details || {}
      else this.state.error = error.message
    } finally {
      this.state.saving = false
    }
  }

  beforeRender() {
    const view = this.state.view
    this.state.html = view?.journal ? markdownView(view.journal) : ''
  }

  CSS = `:fez {
display:block;.dd-form{display:grid;gap:var(--space-4)}.dd-check{display:inline-flex;align-items:center;gap:var(--space-2);justify-self:start;font-size:var(--text-sm);font-weight:var(--weight-medium);cursor:pointer}.dd-journal{display:grid;gap:var(--space-2)}.dd-journal-head{display:flex;align-items:center;justify-content:space-between;min-height:28px}.dd-label{font-size:var(--text-sm);font-weight:var(--weight-semibold)}.dd-read{max-height:50vh;padding:var(--space-3);overflow-y:auto;border:1px solid var(--color-border);border-radius:var(--radius-md);background:var(--color-bg-subtle)}.dd-note{display:grid;place-items:center;min-height:160px}.dd-error{color:var(--color-danger);font-size:var(--text-sm)}
}`

  HTML = `{#if state.loading}
<div class="dd-note"><ui-spinner size="lg"></ui-spinner></div>
{:else if !state.view}
<div class="dd-note"><ui-empty icon="warning-circle" title="Could not load the day" text={state.error}></ui-empty></div>
{:else}
<form class="dd-form" onsubmit="fez.submit(event)" novalidate>
<ui-input name="label" label="Name this day" value={state.view.label || ''} placeholder="A birthday, a launch, a day off" maxlength="100" error={state.errors.label}></ui-input>
<label class="dd-check"><input type="checkbox" name="circled" checked={state.view.circled}> Circle this day</label>
<div class="dd-journal">
{#if state.writing}
<ui-md-editor name="journal" label="Journal" value={state.view.journal || ''} rows="8" placeholder="What happened, what you thought, what to remember" error={state.errors.journal}></ui-md-editor>
{:else}
<div class="dd-journal-head">
<span class="dd-label">Journal</span>
<ui-button size="sm" variant="ghost" icon="pencil-simple" label="Edit" onclick="fez.write()"></ui-button>
</div>
<div class="dd-read md-doc">{@html state.html}</div>
{/if}
</div>
{#if state.error}<p class="dd-error">{state.error}</p>{/if}
<div class="dialog-actions">
<ui-button label="Cancel" onclick="Dialog.cancel()"></ui-button>
<ui-button type="submit" variant="primary" label="Save" :loading="state.saving"></ui-button>
</div>
</form>
{/if}`
};
}

Fez('calendar-day-dialog', __fez_component_0);

export default __fez_component_0;
